import { render, staticRenderFns } from "./HrTrainPro.vue?vue&type=template&id=5c4ac532&scoped=true&"
import script from "./HrTrainPro.vue?vue&type=script&lang=js&"
export * from "./HrTrainPro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4ac532",
  null
  
)

export default component.exports